import type { CustomAnalyticsChart } from "@redotech/redo-analytics-common/reports/custom-analytics-chart";
import { RedoBarChart } from "@redotech/redo-web/arbiter-components/charts/bar-chart/redo-bar-chart";
import { Flex } from "@redotech/redo-web/flex";
import { memo, useMemo } from "react";
import * as styles from "./chart-body-bar.module.css";
import { buildBarChartSeries } from "./custom-analytics-chart-card-utils";

export const BarChartBody = memo(function BarChartBody({
  chart,
  formatValue,
}: {
  chart: CustomAnalyticsChart;
  formatValue: (value: number) => string;
}) {
  const barSeries = useMemo(
    () => buildBarChartSeries(chart.series),
    [chart.series],
  );

  return (
    <Flex className={styles.container} w="full">
      <RedoBarChart
        labels={chart.labels}
        legendPosition="bottom"
        series={barSeries}
        tooltipFormat={{
          valueFormatter: (value) => formatValue(value),
          showSeriesNames: chart.series.length > 1,
        }}
        valueAxisFormatter={formatValue}
      />
    </Flex>
  );
});
